export default __webpack_public_path__ + "static/media/es.679e1f6b.svg";